<template>
    <div :style="style" v-if="src">
        <!--        -->
        <!--        -->
        <!--        :height="height"-->
        <!--        :max-height="maxHeight"-->
        <!--        :max-width="maxWidth"-->
        <!--        -->
        <!--        :width="width"-->
        <!--        -->
        <vue-core-video-player
            :src="src"
            :volume="volume"
            :muted="muted"
            :controls="controls"
            :autoplay="autoplay"
            @error="errorHandler()"
            class="video-player"
            ref="core_video_player"
        ></vue-core-video-player>
    </div>
</template>

<script>
    // import Vue from 'vue';

    export default {
        props: {
            src: {
                type: [String, null]
            },
            controls: {
                type: [Boolean, String],
                default: 'auto',
                validator: (value) => ['fixed', 'auto', true, false].includes(value)
            },
            autoplay: {
                type: Boolean,
                default: false
            },
            volume: {
                type: Number,
                default: 0.5
            },
            muted: {
                type: Boolean,
                default: false
            },
            maxWidth: {
                type: [String, null],
                default: 'auto'
            },
            width: {
                type: [String, null],
                default: 'auto'
            },
            maxHeight: {
                type: [String, null],
                default: 'auto'
            },
            height: {
                type: [String, null],
                default: 'auto'
            },
            play: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            style() {
                return {
                    'max-width': this.parse(this.maxWidth),
                    'width': this.parse(this.width),
                    'max-height': this.parse(this.maxHeight),
                    'height': this.parse(this.height),
                };
            }
        },
        methods: {
            parse(value) {
                return value.includes('%') ? value : (value.replace('px', '') + 'px');
            },
            errorHandler() {
                alert('An error occurred while trying to play this video, please refresh the page and try again.')
            }
            // setFullscreen() {
            //     if(this.$refs.core_video_player) {
            //         this.$refs.core_video_player.$data.fullscreen = true;
            //     }
            // }
        },
        mounted() {
            // this.setFullscreen();
        },
        watch: {
            play(val) {
                setTimeout(() => {
                    if (val) {
                        this.$refs.core_video_player.play();
                    }
                }, 300);
                if(!val) {
                    this.$refs.core_video_player.pause();
                }
            }
        }
    };
</script>

<style>

    .video-player .vue-core-video-player-control.timespan {
        width: 300px;
        display: flex;
        justify-content: flex-start;
        padding-left: 50px;
    }

    .video-player .spinner circle {
        stroke: #0174EA;
    }

    .video-player .vcp-progress-played {
        background-color: #0174EA;
    }
</style>